import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './App.css'
import './styles/detail-pages.css'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './lib/queryClient'
import { AuthProvider } from './contexts/auth'
import { HealthProvider } from './contexts/health/HealthContext'
import { RealtimeWebSocketProvider } from './contexts/RealtimeWebSocketContext'
import { SiteProvider } from './contexts/site'
import { BrowserRouter } from 'react-router-dom'
import { addPerformanceHints } from './lib/utils/performance-optimization'
import { initSentry } from './lib/sentry'
import * as Sentry from '@sentry/react'
import './utils/console-monitor' // Initialize console monitoring

// Initialize Sentry before anything else if DSN is provided
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

if (sentryDsn) {
  // Initialize Sentry (async if using loader script)
  initSentry(sentryDsn)
    .then(() => {
      // Verify Sentry is actually initialized (silently)
      setTimeout(() => {
        const client = Sentry.getClient();
        if (!client) {
          console.warn('[Sentry] Failed to initialize - client not created');
        }
      }, 100);
      
      // Add global error handler as a safety net (Sentry should catch these automatically, but this ensures we log them)
      window.addEventListener('error', (event) => {
        console.error('Global error caught:', event.error);
      });
      
      window.addEventListener('unhandledrejection', (event) => {
        console.error('Unhandled promise rejection:', event.reason);
      });
    })
    .catch((error) => {
      console.error('[Sentry Init] Failed to initialize Sentry:', error);
    });
} else {
  console.warn('⚠️ Sentry DSN not configured. Error tracking disabled.');
}

// Log version information to console
console.log(
  `%c🚀 Nodus App %c${__APP_VERSION__} (app-nodus-${__APP_ENVIRONMENT__}) %c${(__APP_COMMIT_SHA__ || 'git').substring(0, 7)}`,
  'background: #1e293b; color: white; padding: 2px 6px; border-radius: 3px 0 3px; font-weight: bold;',
  'background: #334155; color: white; padding: 2px 6px; font-weight: bold;',
  'background: #475569; color: white; padding: 2px 6px; border-radius: 0 3px 3px 0;'
);
console.log(`Build timestamp: ${new Date(__BUILD_TIMESTAMP__).toLocaleString()}`);

// Add performance optimization hints
addPerformanceHints();

ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <SiteProvider>
            <RealtimeWebSocketProvider>
              <HealthProvider showToast={true}>
                <App />
              </HealthProvider>
            </RealtimeWebSocketProvider>
          </SiteProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  // </React.StrictMode>
)
